<template>
    <v-sheet>
        <h5 class="page-text page-text--lg mb-8 mb-lg-16">직종</h5>
        <p class="page-text line-height-15">{{ employment?.typesTexts?.join?.("/") || "-" }}</p>
    </v-sheet>
</template>

<script>
export default {
    props: {
        employment: { type: Object, default: () => ({}) },
    },
};
</script>

<style>
</style>